import React from 'react';

const EnterKeyIcon = (
  { color = 'var(--icon-subdued)', fill = 'var(--background-highlight)', width = 24, height = 24, ...rest },
  ref
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <rect width={width} height={height} rx="4" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 13.6665C4.5 13.4455 4.5878 13.2335 4.74408 13.0772C4.90036 12.921 5.11232 12.8332 5.33333 12.8332H15.3333C15.9964 12.8332 16.6323 12.5698 17.1011 12.1009C17.5699 11.6321 17.8333 10.9962 17.8333 10.3332V6.99984C17.8333 6.77882 17.9211 6.56686 18.0774 6.41058C18.2337 6.2543 18.4457 6.1665 18.6667 6.1665C18.8877 6.1665 19.0996 6.2543 19.2559 6.41058C19.4122 6.56686 19.5 6.77882 19.5 6.99984V10.3332C19.5 11.4382 19.061 12.498 18.2796 13.2794C17.4982 14.0609 16.4384 14.4998 15.3333 14.4998H5.33333C5.11232 14.4998 4.90036 14.412 4.74408 14.2558C4.5878 14.0995 4.5 13.8875 4.5 13.6665Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.74399 14.2558C4.58776 14.0996 4.5 13.8877 4.5 13.6667C4.5 13.4457 4.58776 13.2338 4.74399 13.0775L8.07732 9.74418C8.23449 9.59238 8.44499 9.50839 8.66349 9.51029C8.88199 9.51218 9.091 9.59982 9.2455 9.75433C9.40001 9.90884 9.48765 10.1178 9.48955 10.3363C9.49145 10.5548 9.40745 10.7653 9.25565 10.9225L6.51149 13.6667L9.25565 16.4108C9.33525 16.4877 9.39873 16.5797 9.44241 16.6813C9.48608 16.783 9.50907 16.8924 9.51003 17.003C9.51099 17.1137 9.48991 17.2234 9.44801 17.3258C9.40611 17.4282 9.34423 17.5213 9.26598 17.5995C9.18774 17.6778 9.0947 17.7396 8.99228 17.7815C8.88987 17.8234 8.78014 17.8445 8.66949 17.8436C8.55884 17.8426 8.44949 17.8196 8.34782 17.7759C8.24615 17.7323 8.15419 17.6688 8.07732 17.5892L4.74399 14.2558Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(EnterKeyIcon);
